import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export const ConfirmationModal = ({ show, message, handleConfirm, onHide }) => (
  <Modal
    show={show}
    onHide={onHide}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">Confirmation</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="didxl" size="sm" onClick={onHide}>
        Close
      </Button>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          handleConfirm();
          onHide();
        }}
      >
        Yes
      </Button>
    </Modal.Footer>
  </Modal>
);
